import apiClient from '@/lib/api/apiClient'
import { throwServiceError } from './serviceHelpers'

/** Angular risk adjustment → `POST /api/update_risk_rating/:id`. */
export async function updateRiskRating(
  applicationId: string | number,
  payload: { risk_rating: string; note: string; applicant_id: string | number },
): Promise<void> {
  try {
    await apiClient.post(`/api/update_risk_rating/${applicationId}`, payload)
  } catch (error) {
    throwServiceError(error, 'Failed to update risk rating.')
  }
}

export async function getMaxRentHistory(
  applicationId: string | number,
  params: { page?: number; perPage?: number; sortBy?: string; orderBy?: string },
): Promise<{ data: unknown[]; current?: number; last?: number }> {
  try {
    const search = new URLSearchParams()
    if (params.page) search.append('page', String(params.page))
    if (params.perPage) search.append('perPage', String(params.perPage))
    if (params.sortBy) search.append('sortBy', params.sortBy)
    if (params.orderBy) search.append('orderBy', params.orderBy)
    const response = await apiClient.get<{ data: unknown[]; current?: number; last?: number }>(
      `/api/max_rent_history/${applicationId}?${search.toString()}`,
    )
    return response.data
  } catch (error) {
    throwServiceError(error, 'Failed to load max rent history.')
  }
}

export async function getPreviousApplicationList(
  applicantId: string | number,
): Promise<{ data?: unknown[] }> {
  try {
    const response = await apiClient.get<{ data?: unknown[] }>(
      `/api/previous_application_list/${applicantId}`,
    )
    return response.data ?? {}
  } catch (error) {
    throwServiceError(error, 'Failed to load previous applications.')
  }
}
